import { apiGet } from '../api'

export const get_me = () => {
  return apiGet({
    endpoint: 'user/me'
  })
}
